<ng-container *ngFor="let item of contextMenuItems">
  <button mat-menu-item (click)="handle(item)" *ngIf="!item.hideIf || !item.hideIf(contextValue)">
    <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
    <span>{{ item.name | translate }}</span>
  </button>
</ng-container>